import React from "react";
import styled from "styled-components";
import Reveal from "../Reveal";
import { Shell } from "./ui";

const Outer = styled.section`
  padding: clamp(48px, 7vw, 84px) 0;
`;

const Box = styled.div`
  position: relative;
  background: linear-gradient(135deg, #1a1030 0%, #0c0a14 60%);
  border: 1.5px solid rgba(155, 81, 255, 0.25);
  border-radius: 24px;
  padding: clamp(34px, 6vw, 64px);
  text-align: center;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 50% 60% at 50% 0%, rgba(155, 81, 255, 0.28), transparent 65%),
      radial-gradient(ellipse 40% 50% at 100% 100%, rgba(124, 58, 237, 0.18), transparent 60%);
    pointer-events: none;
  }
`;

const Title = styled.h2`
  position: relative;
  font-size: clamp(1.6rem, 4vw, 2.6rem);
  font-weight: 900;
  letter-spacing: -0.035em;
  color: #fff;
  line-height: 1.1;
  margin-bottom: 16px;

  em {
    font-style: normal;
    background: linear-gradient(135deg, #c084fc, #9b51ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Sub = styled.p`
  position: relative;
  font-size: clamp(0.92rem, 1.8vw, 1.05rem);
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.7;
  max-width: 480px;
  margin: 0 auto 30px;
`;

const Btns = styled.div`
  position: relative;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
`;

const Primary = styled.button`
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  color: #12091f;
  font-weight: 800;
  font-size: 0.92rem;
  padding: 14px 28px;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 0.12s, box-shadow 0.14s;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.3);

  &:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4); }
`;

const Ghost = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-weight: 700;
  font-size: 0.92rem;
  padding: 14px 26px;
  border-radius: 12px;
  border: 1.5px solid rgba(255, 255, 255, 0.22);
  transition: background 0.14s, border-color 0.14s;

  &:hover { background: rgba(255, 255, 255, 0.08); border-color: rgba(255, 255, 255, 0.4); }
`;

export default function FinalCta({ onSeeJobs }) {
  return (
    <Outer aria-labelledby="cta-title">
      <Shell>
        <Reveal>
          <Box>
            <Title id="cta-title">
              Pronto para <em>construir com a gente?</em>
            </Title>
            <Sub>
              Encontre a vaga certa ou mande seu portfólio. Se você tem vontade de fazer
              acontecer, a Guebly tem espaço.
            </Sub>
            <Btns>
              <Primary onClick={onSeeJobs}>
                Ver vagas abertas <span aria-hidden="true">→</span>
              </Primary>
              <Ghost href="/banco-de-talentos">
                Banco de talentos
              </Ghost>
            </Btns>
          </Box>
        </Reveal>
      </Shell>
    </Outer>
  );
}
